import { createPasswordPolicy, PasswordPolicy } from '@acme/b2b/security';
import { ApiService } from '@b2b/common/services/api/types';
import { AuthenticationService, AuthenticationServiceModule } from '@b2b/common/services/auth/authentication.service';
import { PermissionsService } from '@b2b/common/services/permissions';
import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';

AddUserController.$inject = [
  '$scope',
  '$uibModalInstance',
  'ValidateService',
  'PermissionsService',
  'ApiService',
  'AuthService',
  'AuthenticationService',
  'DepartmentsData',
  'PasswordPolicyData',
];

function AddUserController(
  $scope: IScope & { addUser: TODO },
  $uibModalInstance: UIBModal<TODO>,
  ValidateService: TODO,
  PermissionsService: PermissionsService,
  ApiService: ApiService,
  AuthService: TODO,
  authenticationService: AuthenticationService,
  DepartmentsData: TODO,
  PasswordPolicyData: PasswordPolicy | null
) {
  const ctrl = {
    model: {
      submitTries: 0,
      valid: true,
      inviteType: '',
      firstName: '',
      lastName: '',
      email: '',
      confirmEmail: '',
      userName: '',
      password: '',
      tenantId: '',
      departmentId: null,
      title: '',
      list: [] as TODO[],
    },
    user: AuthService.getCookie('user'),
    errors: [] as TODO[],
    departments: [] as TODO[],
    passwordPolicy: createPasswordPolicy(PasswordPolicyData ?? {}),

    init: function () {
      $scope.$watch('addUser.model.email', function (value: TODO) {
        console.log(value);
        if (value.length > 0) {
          if (value.indexOf(',') > 0) {
            ctrl.model.list = value.split(',');
          } else if (value.indexOf(';') > 0) {
            ctrl.model.list = value.split(';');
          } else {
            ctrl.model.list = [value];
          }
        } else {
          ctrl.model.list = [];
        }
      });

      ctrl.departments = DepartmentsData || [];

      ctrl.setInviteType();
    },

    setInviteType: function () {
      if (ctrl.hasSSO()) {
        ctrl.model.inviteType = 'sso';
      } else if (PermissionsService.check('USERS_INVITE')) {
        ctrl.model.inviteType = 'email';
      } else if (PermissionsService.check('USERS_CREATE')) {
        ctrl.model.inviteType = 'user';
      }
    },

    hasSSO: function () {
      return authenticationService.isSSO();
    },

    hasErrors: function () {
      return ctrl.errors.length > 0;
    },

    hasList: function () {
      return ctrl.model.list.length > 0;
    },

    checkEmail: function (email) {
      return ValidateService.validate([{ email: email }]);
    },

    checkUserName: function () {
      if (ctrl.model.submitTries > 0) {
        ctrl.model.valid = ValidateService.validate([{ len: { value: ctrl.model.userName } }]);
      }
      return ctrl.model.valid;
    },

    checkPassword: function () {
      if (!ctrl.hasSSO() && ctrl.model.submitTries > 0) {
        ctrl.model.valid = ValidateService.validate([{ password: ctrl.model.password }]);
      }
      return ctrl.model.valid;
    },

    checkValid: function () {
      if (ctrl.model.submitTries > 0) {
        ctrl.model.valid = ValidateService.validate([{ email: ctrl.model.email }]);
      }
      return ctrl.model.valid;
    },

    showSend: function () {
      return true;
    },

    validate: function () {
      const validators: TODO = [
        {
          field: 'invite-users-email',
          email: ctrl.model.email,
        },
        {
          field: 'invite-users-email-confirm',
          equal: [ctrl.model.email, ctrl.model.confirmEmail],
        },
      ];

      return ValidateService.validate(validators);
    },

    checkValidField: function (name) {
      const errors = ValidateService.getErrorHash();

      return !errors[name];
    },

    done: function () {
      ctrl.model.submitTries++;
      switch (ctrl.model.inviteType) {
        case 'email':
          if (ctrl.checkValid()) {
            ApiService.userProxy
              .invite(ctrl.model.list.join(','))
              .then((response) => ctrl.success(response))
              .catch((response) => ctrl.error(response));
          }
          break;

        case 'user':
          if (ctrl.checkUserName() && ctrl.checkPassword()) {
            ApiService.user
              .create({
                firstName: '',
                lastName: '',
                email: '',
                userName: ctrl.model.userName,
                password: ctrl.model.password,
                tenantId: ctrl.user.tenantId,
              })
              .then((response) => ctrl.success(response))
              .catch((response) => ctrl.error(response));
          }
          break;

        case 'sso':
          if (ctrl.validate()) {
            ApiService.userProxy
              .create({
                firstName: ctrl.model.firstName,
                lastName: ctrl.model.lastName,
                email: ctrl.model.email,
                title: ctrl.model.title,
                departmentId: ctrl.model.departmentId || null,
                tenantId: ctrl.user.tenantId,
              })
              .then((response) => ctrl.success(response))
              .catch((response) => ctrl.error(response));
          }
          break;
      }
    },

    cancel: function () {
      $uibModalInstance.dismiss('cancel');
    },

    success: function (response) {
      $uibModalInstance.close(response);
    },

    error: function (response) {
      console.log('error: ', response.data.error);
      ctrl.errors = [{ message: response.data.error }];
    },
  };

  $scope.addUser = ctrl;
  ctrl.init();
}

export const AddUserControllerModule = angular
  .module('acme.view.application.users.add.controllers', [
    'acme.common.service.permissions',
    'acme.common.service.validate',
    'acme.common.service.api',
    'acme.common.service.auth',
    AuthenticationServiceModule,
  ])
  .controller('AddUserController', AddUserController).name;
